import {Component, OnInit, Input, Output, EventEmitter} from '@angular/core';

@Component({
  selector: 'app-button',
  template: `<button (click)="onClick()" [disabled]="disabled">
     {{ text }}
  </button>`,
  styles: [
    `
      button {
        background-color: #c92223;
        border: 0;
        color: #fff;
        border-radius: 5px;
        width: 100%;
        padding: 6px;
        font-size: 14px;
        margin-top: 0px;
      }
      button:hover {
        opacity: 0.8;
        outline: none;
        transition: 0.5s;
      }
    `,
  ],
  standalone: true,
})
export class ButtonComponent implements OnInit {
  @Input() text!: string;
  @Input() disabled!: boolean;
  @Output() clickEvent = new EventEmitter();
  constructor () {}

  ngOnInit(): void {}

  onClick() {
    this.clickEvent.emit();
  }
}
